import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const requestAPI = {
  // Get single request
  getRequest: (requestId) => api.get(`/requests/${requestId}/`),
  // Send PO for approval
  postSubmitForApproval: (requestId) =>
    api.post(`/requests/${requestId}/submitForApproval/`),

  // Update request status
  updateRequestStatus: (requestId, data) =>
    api.patch(`/requests/${requestId}/status/`, data),

  // Approve request
  postApproveRequest: (requestId, data) =>
    api.post(`/approve/${requestId}/ApproveRequest/`, data),

  // Get attachments for a request
  getAttachments: (requestId) => api.get(`/requests/${requestId}/attachments/`),

  // Download attachment
  downloadAttachment: (attachmentId) =>
    api.get(`/requests/attachments/${attachmentId}/download/`, {
      responseType: "blob",
    }),
};
